import { AcadNavTabs } from "@components";
import adminRoutes from "./AdminRoutes";

const Admin = () => {
  return <AcadNavTabs routes={adminRoutes} />;
};

export default Admin;
